import {
  EnvironmentProviders,
  inject,
  provideEnvironmentInitializer,
  Provider,
} from '@angular/core';
import { StorageService } from '@techniek-team/storage';
import { firstValueFrom } from 'rxjs';
import { LyceoUser } from './models/lyceo-user.model';
import { UserService } from './service/user/user.service';

export function withClearStorageOnImpersonator(): (Provider | EnvironmentProviders)[] {
  return [
    provideEnvironmentInitializer(() => {
      const storage = inject(StorageService);
      const userService = inject(UserService);

      const checkForImposter = async () => {
        const user = await firstValueFrom(userService.currentUser<LyceoUser>(), {
          defaultValue: undefined,
        });

        const imposterCacheId = await storage.get('imposterCacheId');
        if (user) {
          if (!('impersonator' in user && user.impersonator)) {
            if (imposterCacheId) {
              //eslint-disable-next-line no-console
              console.log(
                `%c Found lingering IMPOSTER cache!. Clearing all storage.`,
                `background: #d49917; color: #f7f9f9; font-weight: bold; padding: 8px; border-radius: 4px; margin: 8px;`,
              );
              await storage.clearAll();
            }
            return Promise.resolve();
          }

          if (imposterCacheId === user.id) {
            return Promise.resolve();
          }
          //eslint-disable-next-line no-console
          console.log(
            `%c An IMPOSTER is found!. Clearing all storage.`,
            `background: #d49917; color: #f7f9f9; font-weight: bold; padding: 8px; border-radius: 4px; margin: 8px;`,
          );
          await storage.clearAll();
          await storage.set('imposterCacheId', user.id);
        }
        return Promise.resolve();
      };

      void checkForImposter();
    }),
  ];
}
